import { http } from "../config.api.js"
// 幕墙登记 API_CurtainWall
export const listScreenWall = (pageInfo, params) => { return http.get("/screenWall/screenWalls/" + pageInfo, { urlParams: params }).then(res => res.data); };

export const listScreenWallByStatus = (pageInfo, params) => {
    return http.get("/screenWall/listScreenWallByStatus/" + pageInfo, { urlParams: params }).then(res => res.data);
};

export const listItem = (pageInfo, params) => { return http.get("/item/findHyItemsByProId/" + pageInfo, { urlParams: params }).then(res => res.data); };

export const getCurtainWallDetail = params => { return http.get("/screenWall/getScreenWallInfo", { urlParams: params }).then(res => res.data); };

export const saveCurtainWall = params => { return http.post("/screenWall/add", params).then(res => res.data); };

export const updateCurtainWall = params => { return http.post("/screenWall/update", params).then(res => res.data); };

export const submitCurtainWall = params => { return http.post("/screenWall/submit", params).then(res => res.data); };

export const reviewCurtainWall = params => { return http.post("/screenWall/review", params).then(res => res.data); };

export const batchDeleteCurtainWall = params => { return http.delete("/screenWall/batchDelete", { urlParams: params }).then(res => res.data); };

export const screenWallDelete = params => { return http.delete("/screenWall/delete", { urlParams: params }).then(res => res.data); };

export const wallBack = params => { return http.post("/screenWall/back", params).then(res => res.data); };

export const wallReview = params => { return http.post("/screenWall/review", params).then(res => res.data); };

// 根据单位工程id获取监理单位
export const getJLUnit = params => { return http.get("item/getJsUnitsByItem", { urlParams: params }).then(res => res.data); };

// 外窗
export const listWindowOutsideByStatus = (pageInfo, params) => { return http.get("/windowOutside/listWindowOutsideByStatus/" + pageInfo, { urlParams: params }).then(res => res.data); };

export const getOuterExt = params => { return http.get("/windowOutside/getWindowOutsideInfo", { urlParams: params }).then(res => res.data); };

export const getOuterDetail = params => { return http.get("/windowOutside", { urlParams: params }).then(res => res.data); };

export const outerSave = params => { return http.post("/windowOutside/update", params).then(res => res.data); };

export const outerSubmit = params => { return http.post("/windowOutside/submit", params).then(res => res.data); };

export const outerReview = params => { return http.post("/windowOutside/review", params).then(res => res.data); };

export const outerBack = params => { return http.post("/windowOutside/back", params).then(res => res.data); };

export const outerDelte = params => { return http.delete("/windowOutside/delete", { urlParams: params }).then(res => res.data); };

// /item/getJsUnitsByItem/{itemId:"",userId:""}
// 获取监理单位
export const getJsUnitsByItem = params => { return http.get("/item/getJsUnitsByItem", { urlParams: params }).then(res => res.data); };

//审核履历
export const listAuditRecords = params => { return http.get("/auditRecord/listScreenwallAndWindowRecords", { urlParams: params }).then(res => res.data); };


// WEBPACK FOOTER //
// ./src/api/project/api_curtainWall.js